import isomorphicUnfetch from 'isomorphic-unfetch';
import { baseUrlOf } from '../../lib/ssr';
const {
  abortableFetch
} = require('abortcontroller-polyfill/dist/cjs-ponyfill');
const { fetch } = abortableFetch({
  fetch: isomorphicUnfetch,
  Request: isomorphicUnfetch.Request
});

const get = (req, controller = undefined) => {
  const baseUrl = req ? baseUrlOf(req) : '';
  return fetch(`${baseUrl}/api/countries`, {
    headers: {
      Accept: 'application/json'
    },
    signal: controller ? controller.signal : undefined
  }).then(res => res.json());
};

const countries = {
  get: get
};
export default countries;
